import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import FAQSupport from "./pages/FAQSupport";
import Hazaribagh from "./pages/Hazaribagh";
import Koderma from "./pages/Koderma";
import Ramgarh from "./pages/Ramgarh";
import Ranchi from "./pages/Ranchi";
import Bokaro from "./pages/Bokaro";
import Jamshedpur from "./pages/Jamshedpur";


export default function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/faq-support" element={<FAQSupport />} />
        <Route path="/hazaribagh" element={<Hazaribagh />} />
        <Route path="/koderma" element={<Koderma />} />
        <Route path="/ramgarh" element={<Ramgarh />} />
        <Route path="/ranchi" element={<Ranchi />} />
        <Route path="/bokaro" element={<Bokaro />} />
        <Route path="/jamshedpur" element={<Jamshedpur />} />
      </Routes>
      <Footer />
    </Router>
  );
}